import React from 'react';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';
import { Color, Icon as ElementsIcon, Spin } from '@bb/elements-web';
import SupraAccessCard from './components/SupraAccessCard';
import MyKeyCard from './components/MyKeyCard';
import NotificationsCard from './components/NotificationsCard';
import ManagedAccessCard from './components/ManagedAccessCard';
import {
  SupraAccessDetailsPageProvider,
  useSupraAccessDetailsPageContext,
} from './SupraAccessDetailsPageContext';

const SupraAccessDetailsPageContent: React.FC = () => {
  const history = useHistory();
  const { loading, isSingleAccessEnabledForBoard } =
    useSupraAccessDetailsPageContext();

  return (
    <StyledPageWrapper>
      <StyledHeader>
        <BackButton
          onClick={() => history.goBack()}
          aria-label="Back"
          data-cy="supra-access-details-back"
        >
          <ElementsIcon
            icon="fullArrowLeftOutlined"
            color="primary"
            size={20}
          />
        </BackButton>
        <h1>Your Subscription</h1>
      </StyledHeader>
      {loading ? (
        <SpinnerWrapper>
          <Spin dataCy={''} />
        </SpinnerWrapper>
      ) : (
        <StyledCardsContainer>
          <SupraAccessCard />
          <MyKeyCard />
          <NotificationsCard />
          {isSingleAccessEnabledForBoard && <ManagedAccessCard />}
        </StyledCardsContainer>
      )}
    </StyledPageWrapper>
  );
};

/**
 * Page that displays the details of the user's Supra Access subscription:
 * subscription/plan info, eKey serial & PIN, notification preferences, and
 * (when enabled for the board) the Managed Access toggle.
 *
 * Reached from the "View Details" button on the Supra Access card in the
 * Current Services section of the Subscriptions & Payments page.
 */
const SupraAccessDetailsPage: React.FC = () => (
  <SupraAccessDetailsPageProvider>
    <SupraAccessDetailsPageContent />
  </SupraAccessDetailsPageProvider>
);

export default SupraAccessDetailsPage;

const StyledPageWrapper = styled.div`
  padding: 24px;
  max-width: 1200px;
  margin: 0 auto;
`;

const StyledHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 24px;
  h1 {
    margin: 0;
    font-size: 24px;
    font-weight: 500;
    color: ${Color.BLACK};
  }
`;

const BackButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: 0;
  padding: 0;
  cursor: pointer;
`;

const StyledCardsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const SpinnerWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: 48px 0;
`;
